const colors = {
  300: "#c9f9a3",
  500: "#97C673",
  700: "#679546",
};

export default colors;
